import React, { Component } from 'react';
import { Chart } from "react-google-charts";
import blueHeart from '../assets/blue-heart.png';
import redSkull from '../assets/red-skull.png';

/*chartType = "BarChart"
const options = {
    legend: 'none',
    backgroundColor: { fill: 'transparent' },
    colors: ['#C00B0B', '#ABABAB', '#1A22F6'],
    chartArea: { width: "100%" },
    hAxis: {
        minValue: 0,
        textPosition: "none",
        gridlines: { count: 0 },
        baselineColor: "none",
    },
    vAxis: { textPosition: "none", },
};*/


const options = {
    legend: 'none',
    pieSliceText: 'value',
    backgroundColor: { fill: 'transparent' },
    colors: ['#0D6EFD', '#3CE050', '#C00B0B'],
    pieSliceTextStyle: { fontSize: 45 }
};

export class AdminVoteResultDisplay extends Component {
    static displayName = AdminVoteResultDisplay.name;

    title() {
        let voteType = this.props.vote_Type;

        if (this.props.ongoing && this.props.loading) return "LOADING...";
        else if (this.props.ongoing) return "Current Results".concat(this.props.dotStr);
        else {
            if (voteType === 1) { //A or B Choice
                if (this.props.A_Vote === 0 && this.props.B_Vote === 0) return "You Didn't Choose Anything"
                else if (this.props.A_Vote === this.props.B_Vote) return "You Were Indecisive"
                else if (this.props.A_Vote > this.props.B_Vote) return "You Choose Red △"
                else { return "You Choose Blue O"; }
            } else if (voteType > 19) { //Number Choice
                if (this.props.A_Vote === 0 && this.props.B_Vote === 0) return "You Didn't Dial Anything"
                else if (this.props.A_Vote === this.props.B_Vote) return "You JUST Passed"
                else if (this.props.A_Vote > this.props.B_Vote) return "You Failed"
                else { return "You Passed"; }
            } 
        }
    }

    getData() {
        const A = this.props.A_Vote;
        const B = this.props.B_Vote;
        const Neither = ((A + B) > 0) ? 0 : 0.00001;

        return [
            ["O / △", "Count"],
            ["O", B],
            ["No Vote Yet", Neither],
            ["△", A],
        ];
    }
    votes(for_A) {
        const A = this.props.A_Vote;
        const B = this.props.B_Vote;
        const total = A + B;
        if (total === 0) return "No Votes Yet"
        return (for_A) ? A : B;
    }

    render() {

        let voteType = this.props.vote_Type;


        if (voteType === 3) {
            if (this.props.A_Vote === 0) {
                return (
                    <div>
                        <h1>Stay Quiet</h1>
                        <table><tbody>
                            <tr>
                                <td><img className='arrow' src={blueHeart} /></td>
                                <td><img className='arrow' src={blueHeart} /></td>
                                <td><img className='arrow' src={blueHeart} /></td>
                            </tr>
                            <tr>
                                <td><h2>{""}</h2></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody></table>
                    </div>
                )
            } else if (this.props.A_Vote === 1) {
                return (
                    <div>
                        <h1>Stay Quiet</h1>
                        <table><tbody>
                            <tr>
                                <td><img className='arrow' src={redSkull} /></td>
                                <td><img className='arrow' src={blueHeart} /></td>
                                <td><img className='arrow' src={blueHeart} /></td>
                            </tr>
                            <tr>
                                <td><h2>{this.props.noisyPeeps[0]}</h2></td>
                                <td></td>
                                <td></td>
                            </tr>
                        </tbody></table>
                    </div>
                )
            } else if (this.props.A_Vote === 2) {
                return (
                    <div>
                        <h1>Stay Quiet</h1>
                        <table><tbody>
                            <tr>
                                <td><img className='arrow' src={redSkull} /></td>
                                <td><img className='arrow' src={redSkull} /></td>
                                <td><img className='arrow' src={blueHeart} /></td>
                            </tr>
                            <tr>
                                <td><h2>{this.props.noisyPeeps[0]}</h2></td>
                                <td><h2>{this.props.noisyPeeps[1]}</h2></td>
                                <td></td>
                            </tr>
                        </tbody></table>
                    </div>
                )
            } else if (this.props.A_Vote > 2) {
                return (
                    <div>
                        <h1 color='red'>You Failed</h1>
                        <table><tbody>
                            <tr>
                                <td><img className='arrow' src={redSkull} /></td>
                                <td><img className='arrow' src={redSkull} /></td>
                                <td><img className='arrow' src={redSkull} /></td>
                            </tr>
                            <tr>
                                <td><h2>{this.props.noisyPeeps[0]}</h2></td>
                                <td><h2>{this.props.noisyPeeps[1]}</h2></td>
                                <td><h2>{this.props.noisyPeeps[2]}</h2></td>
                            </tr>
                        </tbody></table>
                    </div>
                )
            }
        } 

        let chart = <Chart
            chartType="PieChart"
            data={this.getData()}
            options={options}
            width={"100%"}
            height={"50vh"}
        />;

        let label1 = "";
        let label2 = "";
        let title = <h2>{this.title()}</h2>;
        if (voteType === 1) { //A or B Choice
            label1 = <td><button className="btn btn-primary btn-AA" value="A">△</button><span className="txtVote"> {this.votes(true)}</span></td>;
            label2 = <td><button className="btn btn-primary btn-BB" value="B">○</button><span className="txtVote"> {this.votes(false)}</span></td>;
        } else if (voteType === 2) { //Number Choice
            label1 = <td><button className="btn btn-primary btn-AA" value="A">Incorrect</button><span className="txtVote"> {this.votes(true)}</span></td>;
            label2 = <td><button className="btn btn-primary btn-BB" value="B">Correct</button><span className="txtVote"> {this.votes(false)}</span></td>;
        } 

        let labelsTable = (
            <table><tbody>
                <tr>
                    {label1}
                    {label2}
                </tr>
            </tbody></table>
        )

        return (
            <div>
                {title}
                {chart}
                {labelsTable}
            </div>
        );
    }
}